import * as yup from 'yup';

export const KnowledgeSubDomainFormValidation = yup.object().shape({
    description: yup.string().required('Nome do subdomínio é obrigatório'),
    code: yup.string().required('Código é obrigatório'),
    status: yup.bool().default(true),
    idDomain: yup.string().required('O domínio de conhecimento é obrigatório'),
});
